import React, {useContext, useState} from "react";
import Context from "../../context/Message";
import ClientAvatar from "./ClientAvatar";
import LoginButton from "./LoginButton";
import {getClientNickname} from "../../../../cp/tools";

export const AnonymousMessageCheckbox = ({enabled, checked, onChange, disabled = false}) => {
    const {$locale} = useContext(Context);

    if (!enabled) {
        return null;
    }

    return (
        <span className="message-sendAnonymousSelect">
            <input
                type="checkbox"
                name="anonymous"
                id="anonymous"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
            <label htmlFor="anonymous">{$locale.get('comment.anonymous.select.title')}</label>
        </span>
    );
};

export const MessageTargetSelect = ({targets, target, onChange, disabled = false}) => {
    const {$locale} = useContext(Context);

    if (!targets?.length) {
        return null;
    }

    return (
        <div className="message-target-select-container">
            <select
                name="targetMemberId"
                value={target}
                onChange={onChange}
                disabled={disabled}
            >
                <option value="">{$locale.get('message.target.all')}</option>
                {targets.map(({value, title}) => (
                    <option value={value} key={value}>{title}</option>
                ))}
            </select>
        </div>
    );
};

export const LogoutButton = ({onClick}) => {
    const {$locale} = useContext(Context);

    return (
        <a className="logout-button" onClick={onClick}>{$locale.get('auth.logout')}</a>
    );
};

export default ({onClickNickname, onSubmit}) => {
    const {
        $locale,
        clientNicknameFormat,
        client,
        allowAnonymousMessage,
        maxMessageLength,
        messageTargets,
        showClientLogin,
        logout,
    } = useContext(Context);
    const [sending, setSending] = useState(false);
    const [text, setText] = useState('');
    const [anonymous, setAnonymous] = useState(false);
    const [messageTarget, setMessageTarget] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();

        const data = {
            text,
            anonymous: allowAnonymousMessage ? anonymous : false,
            targetMemberId: messageTarget,
        };

        setSending(true);
        onSubmit(data)
            .then(() => {
                setText('');
                setAnonymous(false);
                setMessageTarget('');
            })
            .finally(() => {
                setSending(false);
            })
        ;
    }

    if (!client) {
        return (
            <LoginButton onClick={showClientLogin} />
        );
    }

    return (
        <form className="message-input" onSubmit={handleSubmit}>
            <ClientAvatar client={client} />
            <div className="content">
                <div className="title">
                    <a onClick={onClickNickname} className="client-name nickname">{getClientNickname(client, clientNicknameFormat)}</a>
                    {' '}
                    <LogoutButton onClick={logout} />
                    {' '}
                    <AnonymousMessageCheckbox
                        enabled={allowAnonymousMessage}
                        checked={anonymous}
                        onChange={(e) => setAnonymous(e.target.checked)}
                        disabled={sending}
                    />
                </div>
                <div className="message-input-text-container">
                    <MessageTargetSelect
                        targets={messageTargets}
                        target={messageTarget}
                        onChange={(e) => setMessageTarget(e.target.value)}
                        disabled={sending}
                    />
                    <div className="text">
                        <div className="message-input-box">
                            <input
                                type="text"
                                name="text"
                                placeholder={$locale.get('comment.input.placeholder')}
                                autoComplete="off"
                                maxLength={maxMessageLength}
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                disabled={sending}
                            />
                            <s className="input-arrow-left" />
                            <input type="submit" value={$locale.get('comment.submit')} disabled={sending} />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}
